/* ==========================================================================
   Kayak Merkezleri — CTA olay takibi (GA4)

   NEDEN BU DOSYA VAR
   Shopify'ın Google entegrasyonu GA4'ü bir "web pixel" içinde, sandbox'lı bir
   iframe'de çalıştırıyor. Bu yüzden ana sayfada `window.gtag` YOK — tema
   tarafındaki tıklamaları oradan gönderemiyoruz.

   Shopify'ın hazır olarak gönderdiği olaylar (page_view, view_item,
   add_to_cart, begin_checkout, purchase, search) BURADA TEKRARLANMAZ.
   Bu dosya yalnızca yeni tasarımın kendi CTA'larını ekler:
   WhatsApp, hesaplayıcılar, filtreler, ölçü seçimi, rehber, SSS…

   NASIL ÇALIŞIYOR
   1. Kendi gtag örneğimizi `send_page_view: false` ile yüklüyoruz — sayfa
      görüntüleme iki kez sayılmasın.
   2. client_id'yi `_ga` çerezinden okuyup açıkça veriyoruz; böylece bu olaylar
      pixel'in oturumuyla aynı kullanıcıya yazılır, ayrı oturum açılmaz.
   3. Aynı olayı `Shopify.analytics.publish` ile de yayınlıyoruz. Şu an kimse
      dinlemiyor; ileride Admin → Müşteri etkinlikleri'nden özel bir pixel
      eklenirse hiçbir tema değişikliği gerekmeden oraya da akar.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.KM_ANALYTICS || {};
  var MEASUREMENT_ID = cfg.measurementId;
  if (!MEASUREMENT_ID) return;

  /* ---------------------------------------------------------------- kurulum */

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  /**
   * GA4 client_id'si `_ga` çerezinde "GA1.1.<client_id>" biçiminde durur.
   * Pixel ile aynı kimliği kullanmazsak olaylar ayrı bir kullanıcıya yazılır.
   */
  function clientIdFromCookie() {
    var m = document.cookie.match(/_ga=GA\d\.\d\.(\d+\.\d+)/);
    return m ? m[1] : null;
  }

  var s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(MEASUREMENT_ID);
  document.head.appendChild(s);

  gtag('js', new Date());

  var config = {
    // Sayfa görüntülemeyi Shopify'ın pixel'i zaten gönderiyor.
    send_page_view: false,
  };
  var cid = clientIdFromCookie();
  if (cid) config.client_id = cid;

  gtag('config', MEASUREMENT_ID, config);

  /* ------------------------------------------------------------------ yardım */

  /*
   * Aynı olay 400 ms içinde tekrar gelirse yut. Gerekli, çünkü bazı
   * kontroller <label> + gizli <input> çifti — etikete tıklamak input'a da
   * sentetik bir click gönderiyor ve ikisi de aynı seçiciye uyuyor.
   */
  var lastKey = '';
  var lastAt = 0;

  function track(name, params) {
    var payload = params || {};

    var key = name + '|' + JSON.stringify(payload);
    var now = new Date().getTime();
    if (key === lastKey && now - lastAt < 400) return;
    lastKey = key;
    lastAt = now;

    if (cfg.debug) {
      // eslint-disable-next-line no-console
      console.log('[KM analytics]', name, payload);
    }

    gtag('event', name, payload);

    // İleride özel pixel eklenirse oraya da aksın.
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) {
      /* pixel yoksa sessizce geç */
    }
  }

  // Aynı etkileşim kısa aralıkla tekrar tetiklenirse (slider sürüklemesi gibi)
  // tek olay say.
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  function textOf(el) {
    return el ? (el.textContent || '').trim().slice(0, 100) : '';
  }

  /* ------------------------------------------------ 1) tıklama tabanlı olaylar
     Tek bir delegated dinleyici — her CTA için ayrı listener bağlamıyoruz ki
     AJAX ile gelen içerik (filtre sonucu, sepet çekmecesi) de kapsansın.
  */

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      // "Ölçüden emin değilim, uzmana sor" — bu da bir WhatsApp bağlantısı,
      // o yüzden genel WhatsApp kuralından ÖNCE gelmeli.
      var expert = closest(t, '[data-km-ask-expert]');
      if (expert) {
        track('uzmana_sor_click', { item_name: cfg.productTitle || '' });
        return;
      }

      // WhatsApp — sitenin birincil dönüşüm kanalı
      var wa = closest(t, 'a[href*="wa.me"]');
      if (wa) {
        track('whatsapp_click', {
          link_url: wa.getAttribute('href'),
          konum: cfg.pageType || '',
          etiket: textOf(wa),
        });
        return;
      }

      // Telefon
      var tel = closest(t, 'a[href^="tel:"]');
      if (tel) {
        track('phone_click', { konum: cfg.pageType || '' });
        return;
      }

      // E-posta (bota karşı korumalı bağlantı JS ile kuruluyor)
      var mail = closest(t, 'a[href^="mailto:"]');
      if (mail) {
        track('email_click', { konum: cfg.pageType || '' });
        return;
      }

      // "Ölçüden emin değilim, uzmana sor" — ürün sayfasındaki danışma CTA'sı
      var expert = closest(t, '[data-km-ask-expert]');
      if (expert) {
        track('uzmana_sor_click', { item_name: cfg.productTitle || '' });
        return;
      }

      // Hesaplayıcının "Listele" butonu — filtrelenmiş koleksiyona gider
      var calcCta = closest(t, '[data-km-skicalc-cta]');
      if (calcCta) {
        track('hesaplayici_listele', {
          seviye: cfg.lastLevel || '',
          hedef: calcCta.getAttribute('href') || '',
        });
        return;
      }

      // Ürün sayfasında ölçü seçimi
      var size = closest(t, '.km-product__size');
      if (size) {
        track('olcu_secildi', {
          item_name: cfg.productTitle || '',
          olcu: textOf(size),
        });
        return;
      }

      // Sepete ekle (Shopify'ın add_to_cart'ı ayrı; bu tıklama niyetini ölçer)
      var add = closest(t, '.km-product__add, .km-stickybar__add, [name="add"]');
      if (add) {
        track('sepete_ekle_click', { item_name: cfg.productTitle || '' });
        return;
      }

      // Rehber sayfası içindekiler
      var guideNav = closest(t, '.km-guide__toc a, .km-guide__nav a');
      if (guideNav) {
        track('rehber_bolum_click', { bolum: textOf(guideNav) });
        return;
      }

      // Blog yazısı içindekiler
      var artNav = closest(t, '.km-article__toc-list a');
      if (artNav) {
        track('yazi_bolum_click', { bolum: textOf(artNav) });
        return;
      }

      // Görsel büyütme
      if (closest(t, '[data-km-lightbox-open]')) {
        track('gorsel_buyut', { item_name: cfg.productTitle || '' });
        return;
      }

      // Bülten — form değil, Shopify üyelik sayfasına giden bir bağlantı.
      // Bu yüzden gönderim değil tıklama ölçülüyor.
      if (closest(t, '.km-newsletter__cta')) {
        track('bulten_cta_click', { konum: cfg.pageType || '' });
        return;
      }

      // Koleksiyon filtresi
      var filter = closest(t, '.km-filters input[type="checkbox"]');
      if (filter) {
        track('filtre_uygulandi', {
          filtre: filter.getAttribute('name') || '',
          deger: filter.value || '',
          secildi: filter.checked,
        });
        return;
      }
    },
    true
  );

  /* ---------------------------------------------- 2) form / değişim olayları */

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;

    // Sıralama
    if (t.matches && t.matches('.km-collection__sort-select, [name="sort_by"]')) {
      track('siralama_degisti', { siralama: t.value });
    }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches) return;

    // İletişim formu (mesaj alanı olan Shopify contact formu)
    if (f.matches('.km-contact__form') || (f.matches('form[action*="/contact"]') && f.querySelector('textarea'))) {
      var konu = f.querySelector('[name="contact[Konu]"]');
      track('iletisim_formu_gonderildi', { konu: konu ? konu.value : '' });
    }

    // Arama
    if (f.matches('form[action*="/search"]')) {
      var q = f.querySelector('input[name="q"]');
      track('arama_gonderildi', { search_term: q ? q.value.slice(0, 100) : '' });
    }
  });

  /* -------------------------------------------------- 3) hesaplayıcı kullanımı
     Slider sürüklerken onlarca olay göndermemek için 900 ms bekliyoruz;
     kullanıcı değeri bırakınca tek olay gider.
  */

  var CALCS = [
    { sel: '[data-km-skicalc]', ad: 'kayak_boyu' },
    { sel: '[data-km-polecalc]', ad: 'baton_boyu' },
    { sel: '[data-km-boardcalc]', ad: 'snowboard_boyu' },
    { sel: '[data-km-helmetcalc]', ad: 'kask_olcusu' },
    // Ürün sayfasındaki gömülü boy hesaplayıcısı
    { sel: '[data-km-calc]', ad: 'urun_boy_onerisi' },
  ];

  CALCS.forEach(function (c) {
    document.querySelectorAll(c.sel).forEach(function (root) {
      var range = root.querySelector('input[type="range"]');
      if (!range) return;

      var send = debounce(function () {
        var active = root.querySelector('[data-km-skicalc-level].is-active, .km-calc__level.is-active');
        var level = active ? textOf(active) : '';
        if (level) cfg.lastLevel = level;

        track('hesaplayici_kullanildi', {
          hesaplayici: c.ad,
          deger: range.value,
          seviye: level,
        });
      }, 900);

      range.addEventListener('input', send);

      root.querySelectorAll('[data-km-skicalc-level], .km-calc__level').forEach(function (btn) {
        btn.addEventListener('click', function () {
          cfg.lastLevel = textOf(btn);
          send();
        });
      });
    });
  });

  /* ----------------------------------------------------------- 4) SSS açılışı */

  document.querySelectorAll('details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      var q = d.querySelector('summary');
      track('sss_acildi', { soru: textOf(q) });
    });
  });

  /* -------------------------------------------------------- 5) arama panelini aç */

  document.querySelectorAll('[data-km-search-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      track('arama_acildi', {});
    });
  });
})();
